import type { ExperimentArm } from "@/types/arm.ts";

// TODO: Maybe a more strict type in the future? This allows for auto conversion but may not be ideal
export type TutorId = number;

export interface TutorDetails {
  tutorId: number;
  userId: number;
  firstName: string;
  lastName: string;
  imageURL: string | null;
  description: string | null;
  defaultClaimMessage: string | null;
  isAutoInterventionsEnabled: boolean;
  status: string | null;
  dateCreated: string | null;
  dateDeleted: string | null;
  capacity?: number;
  experimentArm?: ExperimentArm | string;
  currentRotaActiveFrom?: string | null;
  currentRotaActiveTo?: string | null;
}

export interface Tutor {
  authorPermissions: string[];
  dateCreated: string;
  dateDeleted: string | null;
  dateLastLoggedIn: string;
  defaultClaimMessage: string | null;
  description: string | null;
  email: string;
  firstName: string;
  id: number;
  imageURL: string;
  isAuthor: boolean;
  isAutoInterventionsEnabled: boolean;
  isContractor: boolean;
  isOnline: boolean;
  isSuperAdmin: boolean;
  lastName: string;
  tutorId: number;
  userId: number;
  userName: string;
  userStatus: string;
}

export enum TutorStatus {
  Offline = "Offline",
  Available = "Available",
  Busy = "Busy",
  OnBreak = "OnBreak",
}

export enum TutorStatusString {
  Offline = "offline",
  Available = "available",
  Busy = "busy",
  OnBreak = "on-break",
}

interface Percentage {
  Sequence: number;
  Value: number;
  Color: string;
}

// Note: Unfinished
export interface InterventionMetadata {
  FirstName: string;
  LastName: string;
  YearGroup: string;
  QuizName: string;
  QuizId: number;
  LessonType: string;
  AssignmentId: number;
  AvgScore: number;
  PercentageComplete: number;
  IsProactiveIntervention: boolean;
  RecentQuestionSequence: number;
  RecentQuestionAnswer: string;
  Prompt: string;
  Percentages: Percentage[];
  IsOnFluencyWorksheet: boolean;
}
